<template>
  <div v-if="item">
    <div class="columns is-marginless is-paddingless">
      <div class="column">
        <div class="container" style="display: flex">
          <h1 class="title">{{ item.vinNo }}</h1>
          <div
            class="column-save"
            @click="save()"
            v-if="
              item.conditionChecked &&
              item.transportToName != '' &&
              item.transportVendorId != ''
            "
          >
            <b-button class="is-size-7 btn-save" label="保存" />
          </div>
        </div>
      </div>
      <div
        class="column has-text-right"
        style="margin-top: auto; margin-bottom: auto"
      >
        <div class="container"></div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless">
      <div class="column is-5">
        <div class="container">
          <section class="section is-marginless is-paddingless mb-5">
            <ItemImageGallery :images="item.images()" />
          </section>
        </div>
      </div>
      <div class="column is-7">
        <div class="container">
          <section class="section is-marginless is-paddingless mb-5">
            <h2 class="title is-size-5">車両情報</h2>
            <ItemAuctionTransport
              :item="item"
              :auctions="auctions"
              :isValidate="isValidate"
              :dataJCPackage="dataJCPackage"
              @calc="calc"
              @auctionVendorChanged="auctionVendorChanged"
              @changeIsvalidate="changeIsvalidate"
              @responeValidateItemAuctionTransport="
                responeValidateItemAuctionTransport
              "
            />
            <section class="section is-marginless is-paddingless mb-5">
              <ItemPos :item="item" />
            </section>
            <section class="section is-marginless is-paddingless mb-5">
              <ItemVehicle
                :item="item"
                :previosVinNo="previosVinNo"
                @responeUpdateSuccess="responeUpdateSuccess"
                @responeValidateItemVehical="responeValidateItemVehical"
              />
            </section>
            <section class="section is-marginless is-paddingless mb-5">
              <ItemCondition :item="item" />
            </section>
          </section>
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless">
      <div class="column is-5">
        <div class="container">
          <section class="section is-marginless is-paddingless mb-5">
            <section class="section is-marginless is-paddingless mb-5">
              <ItemCustomer
                :item="item"
                :listCustomerInf="listCustomerInf"
                ref="validateCustomer"
                @responeValidateItemCustomer="responeValidateItemCustomer"
              />
            </section>
            <h2 class="title is-size-5">輸出代行</h2>
            <ItemAAS :item="item" :yards="yards" @calc="calc" />
          </section>
        </div>
      </div>
      <div class="column is-7">
        <div class="container">
          {{ item.a }}
          <section class="section is-marginless is-paddingless mb-5">
            <h2 class="title is-size-5">陸送手配</h2>
            <ItemTransportAsTransport
              :key="item.id"
              :item="item"
              :yards="yards"
              :transportCosts="transportCosts"
              :transportVendors="transportVendors"
              :selectedAuctionVendor="selectedAuctionVendor"
              :isFetching="isFetching"
              :auctions="auctions"
              @saveTransport="saveTransport"
              @auctionVendorChangedTransport="auctionVendorChangedTransport"
              @calc="calc"
              @responeValidateTransportAsTransport="
                responeValidateTransportAsTransport
              "
            />
          </section>
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless">
      <div class="column"></div>
      <div
        class="column has-text-right"
        style="margin-top: auto; margin-bottom: auto"
      ></div>
    </div>
  </div>
</template>
<style>
.column-save {
  margin: 1px 0px 0px 5px;
  text-align: center;
}
.btn-save {
  width: 50px;
  height: 32px;
  background-color: #2d70d3 !important;
  color: #fff !important;
}
</style>
<script>
import itemRepository from '@/repositories/item';
import jcPackage from '@/repositories/jcPackage';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    ItemImageGallery: () => import('@/components/ItemImageGallery.vue'),
    ItemVehicle: () => import('@/components/ItemVehicle.vue'),
    ItemAuctionTransport: () => import('@/components/ItemAuctionTransport.vue'),
    ItemPos: () => import('@/components/ItemPost.vue'),
    ItemAAS: () => import('@/components/ItemAAS.vue'),
    ItemCondition: () => import('@/components/ItemCondition.vue'),
    ItemTransportAsTransport: () =>
      import('@/components/ItemTransportAsTransport.vue'),
    ItemCustomer: () => import('@/components/ItemCustomer.vue'),
  },
  watch: {
    $route: function () {
      this.init();
    },
  },
  data: () => ({
    item: null,
    originalTransportFromName: '',
    originalTransportToName: '',
    toggleDetailItems: false,
    transportCosts: [],
    isFetching: false,
    selectedAuctionVendor: null,
    orderItems: [],
    isValidate: false,
    dataJCPackage: null,
    previosVinNo: '',
    isValidItemVehical: false,
    isValidItemAuctionTransport: false,
    isValidItemTransportAsTransport: false,
    isValidItemCustomer: false,
    listCustomerInf: [],
  }),
  created() {
    this.init();
  },
  computed: {},
  methods: {
    auctionVendorChanged(auction) {
      this.selectedAuctionVendor = auction;
      this.item.yardTransportId = auction ? auction.AA_ID.value : '';
      this.item.yardTransportName = auction
        ? auction.AuctionAreaSatellite.auction
        : '';
      this.item.yardAdressTransport = auction ? auction.Address.value : '';
      this.item.yardAreaTransport = auction ? auction.Big_Area.value : '';
    },
    auctionVendorChangedTransport(auction) {
      this.selectedAuctionVendor = auction;
      this.item.transportFromId = auction ? auction.AA_ID.value : '';
      this.item.transportFromName = auction ? auction.AuctionArea.value : '';
    },
    changeIsvalidate(isValidateBlur) {
      this.item.transportEstimatedArrivalDate = '';
      this.item.transportRequestConfirmDate = '';
      this.item.transportRequestDate = '';
      this.isValidate = isValidateBlur;
    },
    async calc() {
      this.transportCosts = [];
      if (
        !this.item.transportUseYardsForTransportTo ||
        this.item.transportFromId == '' ||
        this.item.transportToArea == '' ||
        this.item.fromYardPlace == null || this.item.fromYardPlace == -1 || this.item.fromYardPlace ==''||
        this.item.customerId == '' || this.item.yardId ==''
      ) {
        return;
      }
      //START QUOCNV 20230529 add new feature get value yard to yard
      let placeYardType = '1';
      if (this.item.yardCategory=='1') {
        placeYardType = '2';
      } 
      //END QUOCNV 20230529 add new feature get value yard to yard
      this.isFetching = true;
      this.transportCosts = await this.$store.dispatch('getTransportCosts', {
        auctionSiteId: this.item.placeId,
        satelliteId: this.item.satelliteId,
        area: this.item.yardId,
        customerId: this.item.customerId,
        category: this.item.yardCategory,
        fromYardPlace: this.item.fromYardPlace,
        placeYardType: placeYardType
      });
      this.isFetching = false;
    },
    async reloadAfterSave() {
      await this.$store.dispatch('fetchOrdersAndBookingItems');
      this.$store.commit('setOrdersCount', this.$store.getters.incompleteItems.length);
    }
    ,
    async save() {
      this.$store.commit('isLoadingApi', true);
      this.item.checktransportRevert = false;
      this.$refs.validateCustomer.validation();
      if (
        this.isValidItemVehical ||
        this.isValidItemAuctionTransport ||
        this.isValidItemTransportAsTransport ||
        this.isValidItemCustomer
      ) {
        this.$store.commit('isLoadingApi', false);
        return;
      }
      this.item.tranRequest++;
      if (!this.item.transportRequestConfirmDate) {
        this.item.transportRequestChange = 'true';
        if (
          this.item.conditionChecked &&
          this.item.transportToName != '' &&
          this.item.transportVendorId != ''
        ) {
          this.item.yardConfirmationDate = String(
            new Date().toLocaleDateString('en-ZA')
          );
          this.item.yardConfirmed = this.$store.state.user.displayName;
        }
        this.item.yardTransportId = this.item.transportFromId;
        this.item.yardTransportName = this.item.transportFromName;
        this.item.id = uuidv4();

        await this.$store.dispatch('createNewTransport', 
        {...this.item,
          invoicePid: '',
          isInvoiceFinish: '0',
          updateTime: (new Date()).getTime()
        });
        await this.reloadAfterSave()

        this.$router.push({
          name: 'booking',
        });
        this.$store.commit('isLoadingApi', false);
        return;
      }

      this.item.id = uuidv4();
      await this.$store.dispatch('createNewTransport',
      {...this.item,
        updateTime: (new Date()).getTime()
      }
      );
      await this.reloadAfterSave()
      this.$router.push({
        name: 'booked',
      });
      this.$store.commit('isLoadingApi', false);
      // jcPackage
      //   .addOrUpdateTransport(this.$store.state.accessTokenJPC, this.item)
      //   .then(async (rs) => {
      //     if (rs.meta.code == 201) {
      //       this.item.id = uuidv4();
      //       await this.$store.dispatch('createNewTransport', this.item);
      //       await jcPackage.updateTransportDetailIdToRikuso(this.$store.state.accessTokenJPC, this.item)
      //       .then(async (rs) => {
              
      //       })
      //       await this.reloadAfterSave()
      //       this.$router.push({
      //         name: 'booked',
      //       });
      //     } else if (rs.meta.code == 400) {
      //       this.item.transportRequestDate = '';
      //       this.item.transportRequestConfirmDate = '';
      //       this.item.transportEstimatedArrivalDate = '';
      //       this.isValidate = true;
      //       this.alertError(rs.meta);
      //     }
      //     this.dataJCPackage = rs.data;
      //   })
      //   .finally(() => {
      //     this.$store.commit('isLoadingApi', false);
      //   });
    },
    alertError(data) {
      this.$buefy.dialog.confirm({
        message: data.message,
        canCancel: false,
        onConfirm: async () => {
          // await itemRepository.delete(this.item.id);
          // this.$buefy.toast.open('削除しました');
          // if (this.nextItem) {
          //   return this.goto(this.nextItem.id);
          // }
          // this.$router.push({ name: 'orders' });
        },
      });
    },
    init() {
      this.item = this.$store.getters.findItemById(this.$route.params.id);
      this.previosVinNo = this.item.vinNo;
      this.setDataInit();
      this.originalTransportFromName = this.item.transportFromName;
      this.originalTransportToName = this.item.transportToName;
      this.auctions = this.$store.state.auctionVendors;
      this.yards = this.$store.state.yardVendors;
      this.transportVendors = this.$store.state.transportVendors;
      this.listCustomerInf = this.$store.state.listCustomerInf;
      this.calc();
    },
    responeValidateItemVehical(listMessage) {
      if (listMessage.msgVinNo != '' || listMessage.msgYear != '') {
        this.isValidItemVehical = true;
      } else {
        this.isValidItemVehical = false;
      }
    },
    responeValidateTransportAsTransport(listMessage) {
      if (listMessage.msgCost != '') {
        this.isValidItemTransportAsTransport = true;
      } else {
        this.isValidItemTransportAsTransport = false;
      }
    },
    responeValidateItemAuctionTransport(listMessage) {
      if (listMessage.msgLotNo != '') {
        this.isValidItemAuctionTransport = true;
      } else {
        this.isValidItemAuctionTransport = false;
      }
    },
    responeValidateItemCustomer(listMessage) {
      if (
        listMessage.msgId != '' ||
        listMessage.msgGrade != '' ||
        listMessage.msgTel != ''
      ) {
        this.isValidItemCustomer = true;
      } else {
        this.isValidItemCustomer = false;
      }
    },
    responeUpdateSuccess() {
      this.previosVinNo = this.item.vinNo;
      this.isValidItemVehical = false;
    },
    saveTransport() {
      this.save();
    },
    setDataInit() {
      this.item.orderDate = moment().format('YYYY-MM-DD');
      this.item.transportFromId = this.item.transportToId;
      this.item.transportFromName = this.item.transportToName;
      this.item.yardTransportId = this.item.transportToId;
      this.item.yardTransportName = this.item.transportToName;
      this.item.yardAdressTransport = this.item.transportToAddress;
      this.item.yardAreaTransport = this.item.transportToArea;
      this.item.lotNo = '';
      this.item.pos = '';
      this.item.postAccount = '';
      this.item.transportVendorId = '';
      this.item.transportVendorName = '';
      this.item.transportToAddress = '';
      this.item.transportToArea = '';
      this.item.transportToId = '';
      this.item.transportToIncharge = '';
      this.item.transportToName = '';
      this.item.transportToPhone = '';
      this.item.transportToRemarks = '';
      this.item.transportRemarks = '';
      this.item.transportNote = '';
      this.item.transportActualCost = 0;
      this.item.transportOutFee = 0;
      this.item.transportNumberPlateCutFee = 0;
      this.item.transportTotalActualCost = 0;
      this.item.transportCost = 0;
      this.item.regularCharge = '';
      this.item.transportTotalCost = 0;
      this.item.transportRequestDate = '';
      this.item.transportRequestConfirmDate = '';
      this.item.transportEstimatedArrivalDate = '';
      this.item.yardConfirmationDate = '';
      this.item.yardConfirmed = '';
      this.item.landTransportationArrangementDate = '';
      this.item.landTransportationArranger = '';
      this.item.transportRequestChange = '';
      this.item.newRequestTransportFlg = 'false';
      this.item.isUpdate = 0;
      this.item.hasNumberPlate = false;
      this.item.handlingCompanyEn = '';
      this.item.handlingCompanyJp = '';
      this.item.invoiceIsuueDate = '';
      this.item.yardCity1 = '';
      this.item.dateConfirmFeeTransport = '';
      this.item.userConfirmFeeTransport = '';
      this.item.transportDetailId = 0;
      this.conditionIsSelftpropelled = false;
      this.conditionIsLoadedTransport = false;
      this.item.checkDupplicateVinNo = true;
      //START QuocNV 20240709 add task 146 
      this.item.isOpenSearchAddressByZipCodePopupFlag = false;
      this.item.suppliersName = '';
      this.item.addressByZipcode = '';
      this.item.areaByZipcode = '';
      //END QuocNV 20240709 add task 146 
    },
  },
};
</script>
